import { SecurityLevelEnum } from '../enums';

export class SecurityLevelInput {
    public name: string;
    public securityLevelEnum: SecurityLevelEnum;
    public isAccessable: boolean | null;

    constructor(name: string, isAccessable: boolean | null, securityLevelEnum: SecurityLevelEnum) {
        this.name = name;
        this.isAccessable = isAccessable;
        this.securityLevelEnum = securityLevelEnum;
    }
}
